<template>
  <div class="select-time-box">
    <img src="@/assets/index/bookmarkleft.svg" class="icon icon-left" alt="" @click="handleClick('last')" v-if='!showLeftHover'/>
    <img src="@/assets/index/leftBlue.svg" class="icon icon-left icon-blue" alt="" @click="handleClick('last')" v-if='showLeftHover'/>

    <a-date-picker v-model:value="value" :bordered="false" :allowClear="false" @change="handleChange" class="input-time" style="position: relative;left:10px;" v-if="calendarType" picker="month">
      <template #suffixIcon></template>
    </a-date-picker>
    <a-date-picker v-model:value="value" :bordered="false" :allowClear="false" @change="handleChange" class="input-time" v-if="!calendarType" picker="week">
      <template #suffixIcon></template>
    </a-date-picker>
    <img src="@/assets/index/bookmark.svg" class="icon icon-right" alt=""  @click="handleClick('next')" v-if='!showRightHover'/>
    <img src="@/assets/index/rightBlue.svg" class="icon icon-right icon-blue" alt=""  @click="handleClick('next')" v-if='showRightHover'/>

  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue'
import dayjs, { Dayjs } from 'dayjs'
export default defineComponent({
  components: {
  },
  props: {
    date: {
      type: Dayjs,
      default: () => { return {} }
    },
    selectType: {
      type: Boolean,
      default: true // true为月份、false为周
    }
  },
  setup(props, { emit }) {
    onMounted(() => {
      //
    })
    const value = ref<Dayjs>(dayjs())
    const calendarType = ref(true)
    watch(props, (newValue) => {
      value.value = newValue.date
      calendarType.value = props.selectType
    })
    const showLeftHover = ref(false)
    const showRightHover = ref(false)

    const handleClick = (type:string) => {
      if (calendarType.value) {
        if (type === 'last') {
          value.value = dayjs(value.value).subtract(1, 'month')
          showLeftHover.value = true
          setTimeout(() => { showLeftHover.value = false }, 100)
          emit('changeNowDate', value.value)
        } else {
          showRightHover.value = true
          setTimeout(() => { showRightHover.value = false }, 100)
          value.value = dayjs(value.value).add(1, 'month')
          emit('changeNowDate', value.value)
        }
      } else {
        if (type === 'last') {
          showLeftHover.value = true
          setTimeout(() => { showLeftHover.value = false }, 100)
          value.value = dayjs(value.value).subtract(1, 'week')
          emit('changeNowDate', value.value)
        } else {
          showRightHover.value = true
          setTimeout(() => { showRightHover.value = false }, 100)
          value.value = dayjs(value.value).add(1, 'week')
          emit('changeNowDate', value.value)
        }
      }
    }
    const handleChange = () => {
      emit('changeNowDate', value.value)
    }
    return {
      value,
      handleClick,
      handleChange,
      calendarType,
      showLeftHover,
      showRightHover
    }
  }
})
</script>
<style lang="scss" scoped>
:deep(.ant-picker-input>input){
  font-size: 18px;

}
.select-time-box{
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.input-time{
  font-size: 18px;
}
.icon{
  width: 28px;
  height: 28px;
  font-size: 28px;
  cursor: pointer;
  z-index: 10;
}
.icon-left{
  margin-right: 40px;
}
</style>
